import React, { useEffect, useState } from "react";
import { AiOutlineInfo, AiOutlineMenu, AiOutlineMenuUnfold, AiTwotoneSecurityScan, AiOutlineEnvironment, AiOutlineSliders, AiOutlineFileText, AiOutlineUser, AiOutlineAudit, AiOutlineTeam, AiOutlineComment, AiOutlineIdcard, AiOutlineContacts } from "react-icons/ai";
import { BsGear, BsListUl, BsFiletypeDoc } from "react-icons/bs";
import { CiLocationArrow1 } from "react-icons/ci";
import { FaSheetPlastic } from "react-icons/fa6";
import { LuNewspaper, LuLayoutDashboard } from "react-icons/lu";
import { GrContact } from "react-icons/gr";
import { MdContactSupport } from "react-icons/md";
import { BsBrowserChrome } from "react-icons/bs";
import { HiChatBubbleBottomCenterText, HiMiniMapPin, HiMiniTruck, HiOutlineClipboardDocument, HiOutlineClipboardDocumentCheck, HiOutlineUserGroup, HiUser, HiUserGroup, HiUsers } from "react-icons/hi2";
import { HiOutlineDocumentMagnifyingGlass } from "react-icons/hi2";
import { MdOutlineContacts } from "react-icons/md";
import { PiSlideshowFill } from "react-icons/pi";
import MultilevelSidebar from "react-multilevel-sidebar";
import "react-multilevel-sidebar/src/Sidebar.css";
import { useNavigate } from "react-router-dom";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";
import { hasReadPermission, initilizeUserInfo } from "../../../service/userService";

const Sidebar = () => {
    let CMSOptionsBackup = [
        {
            content: [
                {
                    id: 1,
                    name: "Pages",
                    href: '/dashboard-page',
                    icon: <HiOutlineClipboardDocument />,
                    securityObject: hasReadPermission('Website.Pages')
                }
            ]
        },
        {
            content: [
                {
                    id: 2,
                    name: "Banner",
                    href: '/dashboard-banner',
                    /*icon: <PiSlideshowFill />,*/
                    icon: <AiOutlineSliders/>,
                    securityObject: hasReadPermission('Website.Banner')
                }
            ]
        },
        {
            content: [
                {
                    id: 3,
                    name: "Menu Items",
                    href: '/dashboard-menu-items',
                    icon: <AiOutlineMenuUnfold />,
                    securityObject: hasReadPermission('Website.MenuItems')
                }
            ]
        },
        {
            content: [
                {
                    id: 4,
                    name: "Contact Inquiries",
                    href: '/dashboard-contact-us',
                    icon: <GrContact />,
                    securityObject: hasReadPermission('Website.ContactInquiries')
                }
            ]
        },
        {
            content: [
                {
                    id: 5,
                    name: "Partner Contact Inquiries",
                    href: '/dashboard-partener-inquires',
                    icon: <MdOutlineContacts />,
                    securityObject: hasReadPermission('Website.PartnerContactInquiries')
                }
            ]
        },
        {
            content: [
                {
                    id: 6,
                    name: "Locations",
                    href: '/dashboard-locations',
                    icon: <AiOutlineEnvironment />,
                    securityObject: hasReadPermission('Website.Locations')
                }
            ]
        },
        {
            content: [
                {
                    id: 7,
                    name: "Settings",
                    href: '/dashboard-settings',
                    icon: <BsGear />,
                    securityObject: hasReadPermission('Website.Settings')
                }
            ]
        }, {
            content: [
                {
                    id: 7,
                    name: "Factsheet",
                    href: '/dashboard-factsheet',
                    icon: <AiOutlineFileText />,
                    securityObject: hasReadPermission('Website.Factsheet')
                }
            ]
        },
        {
            content: [
                {
                    id: 7,
                    name: "Keyfeatures",
                    href: '/dashboard-keyfeatures',
                    icon: <BsListUl />,
                    securityObject: hasReadPermission('Website.KeyFeatures')
                }
            ]
        },
        {
            content: [
                {
                    id: 8,
                    name: "About Section",
                    href: '/dashboard-homeaboutSection',
                    /*icon: <AiOutlineInfo />,*/
                    icon: <AiOutlineAudit/>,
                    securityObject: hasReadPermission('Website.AboutSection')
                }
            ]
        },

        {
            content: [
                {
                    id: 9,
                    name: "Documents",
                    href: '/dashboard-document',
                    icon: <BsFiletypeDoc />,
                    securityObject: hasReadPermission('Website.Documents')
                }
            ]
        }
        ,
        {
            content: [
                {
                    id: 9,
                    name: "Documents View",
                    href: '/dashboard-document-view',
                    icon: <BsFiletypeDoc />,
                    securityObject: hasReadPermission('Website.DocumentsView')
                }
            ]
        }, {
            content: [
                {
                    id: 10,
                    name: "Security",
                    link: setting.securityWebUrl,
                    EventTarget: '_self',
                    icon: <AiTwotoneSecurityScan />,
                    securityObject: hasReadPermission('Security'),
                }
            ]
        }, {
            content: [
                {
                    id: 11,
                    name: "News Letter",
                    href: '/dashboard-newsletter',
                    icon: <LuNewspaper />,
                    securityObject: hasReadPermission('Website.NewsLetter')
                }
            ]
        }
    ].filter((item) => { return item.content[0].securityObject == true; });

    let CMSOptionsWebsite = [
        {
            content: [
                {
                    id: 1,
                    name: "Pages",
                    href: '/dashboard-page',
                    icon: <HiOutlineClipboardDocument />,
                    securityObject: hasReadPermission('Website.Pages')
                }
            ]
        },
        {
            content: [
                {
                    id: 2,
                    name: "Banner",
                    href: '/dashboard-banner',
                    icon: <AiOutlineSliders />,
                    securityObject: hasReadPermission('Website.Banner')
                }
            ]
        },
        {
            content: [
                {
                    id: 3,
                    name: "Menu Items",
                    href: '/dashboard-menu-items',
                    icon: <AiOutlineMenuUnfold />,
                    securityObject: hasReadPermission('Website.MenuItems')
                }
            ]
        },
        {
            content: [
                {
                    id: 4,
                    name: "Contact Inquiries",
                    href: '/dashboard-contact-us',
                    /* icon: <GrContact />,*/
                    icon: <AiOutlineContacts />,
                    securityObject: hasReadPermission('Website.ContactInquiries')
                }
            ]
        },
        {
            content: [
                {
                    id: 6,
                    name: "Locations",
                    href: '/dashboard-locations',
                    /*icon: <CiLocationArrow1 />,*/
                    icon: <AiOutlineEnvironment />,
                    securityObject: hasReadPermission('Website.Locations')
                }
            ]
        },
        {
            content: [
                {
                    id: 7,
                    name: "Settings",
                    href: '/dashboard-settings',
                    icon: <BsGear />,
                    securityObject: hasReadPermission('Website.Settings')
                }
            ]
        },
        {
            content: [
                {
                    id: 8,
                    name: "Factsheet",
                    href: '/dashboard-factsheet',
                    /*icon: <FaSheetPlastic />,*/
                    icon: <AiOutlineFileText />,
                    securityObject: hasReadPermission('Website.Factsheet')
                }
            ]
        },
        {
            content: [
                {
                    id: 9,
                    name: "Key Features",
                    href: '/dashboard-keyfeatures',
                    icon: <BsListUl />,
                    securityObject: hasReadPermission('Website.KeyFeatures')
                }
            ]
        },
        {
            content: [
                {
                    id: 10,
                    name: "About Section",
                    href: '/dashboard-homeaboutSection',
                    /*icon: <AiOutlineInfo />,*/
                    icon: <AiOutlineTeam />,
                    securityObject: hasReadPermission('Website.AboutSection')
                }
            ]
        },
        {
            content: [
                {
                    id: 10,
                    name: "About Us",
                    href: '/dashboard-about-us',
                    /*icon: <AiOutlineInfo />,*/
                    /*icon: <HiUser/>,*/
                    icon: <AiOutlineUser/>,
                    securityObject: hasReadPermission('Website.AboutSection')
                }
            ]
        },
        {
            content: [
                {
                    id: 11,
                    name: "Services",
                    href: '/dashboard-service',
                    /*icon: <AiOutlineInfo />,*/
                    icon: <HiMiniTruck />,
                    securityObject: hasReadPermission('Website.Service')
                }
            ]
        },
        {
            content: [
                {
                    id: 11,
                    name: "Testimonials",
                    href: '/dashboard-testimonial',
                    /* icon: <AiOutlineInfo />,*/
                    /* icon: <HiChatBubbleBottomCenterText/>,*/
                    icon: <AiOutlineComment/>,
                    securityObject: hasReadPermission('Website.Testimonial')
                }
            ]
        },
        {
            content: [
                {
                    id: 11,
                    name: "Clients",
                    href: '/dashboard-client',
                    /*icon: <AiOutlineInfo />,*/
                    icon: <HiOutlineUserGroup />,
                    securityObject: hasReadPermission('Website.Client')
                }
            ]
        },
        {
            content: [
                {
                    id: 12,
                    name: "News",
                    href: '/dashboard-news',
                    icon: <AiOutlineIdcard />,
                    securityObject: hasReadPermission('Website.Client')
                }
            ]
        }
    ].filter((item) => { return item.content[0].securityObject == true; })


    let CMSOptions = [
        {
            content: [
                {
                    id: 1,
                    name: "Partner Contact Inquiries",
                    href: '/dashboard-partener-inquires',
                    icon: <MdOutlineContacts />,
                    securityObject: hasReadPermission('Website.PartnerContactInquiries')
                }
            ]
        }, {
            content: [
                {
                    id: 2,
                    name: "Documents",
                    href: '/dashboard-document',
                    icon: <BsFiletypeDoc />,
                    securityObject: hasReadPermission('Website.Documents')
                }
            ]
        }, {
            content: [
                {
                    id: 3,
                    name: "Documents View",
                    href: '/dashboard-document-view',
                    icon: <HiOutlineDocumentMagnifyingGlass />,
                    securityObject: hasReadPermission('Website.DocumentsView')
                }
            ]
        },
        {
            content: [
                {
                    id: 4,
                    name: "News Letter",
                    href: '/dashboard-newsletter',
                    icon: <LuNewspaper />,
                    securityObject: hasReadPermission('Website.NewsLetter')
                }
            ]
        },
        {
            content: [
                {
                    id: 5,
                    name: "Job Listing",
                    href: '/dashboard-joblisting',
                    icon: <LuNewspaper />,
                    securityObject: hasReadPermission('Website.JobListing')
                }
            ]
        }
    ].filter((item) => { return item.content[0].securityObject == true; });

    let CMSOptionsDashboard = [
        {
            content: [
                {
                    id: 1,
                    name: "Security",
                    link: setting.securityWebUrl,
                    EventTarget: '_Blank',
                    icon: <AiTwotoneSecurityScan />,
                    securityObject: hasReadPermission('Security'),
                }
            ]
        }
    ].filter((item) => { return item.content[0].securityObject == true; });

    const navigate = useNavigate();
    const [openCMS, setIsopenCMS] = useState(false);
    const [openCMSBackend, setIsopenCMSBackend] = useState(false);
    const [openCMSDashboard, setIsopenCMSDashboard] = useState(false);
    const [menuUpdate, setMenuUpdate] = useState(CMSOptionsWebsite);
    const [menuUpdateBackend, setMenuUpdateBackend] = useState(CMSOptions);
    const [menuUpdateDashboard, setMenuUpdateDashboard] = useState(CMSOptionsDashboard);
    const [menuBind, setMenuBind] = useState(false);

    const handleSidebarCMSToggle = (isOpen) => {
        setIsopenCMS(isOpen);
    };
    const handleSidebarCMSBackendToggle = (openCMSBackend) => {
        setIsopenCMSBackend(openCMSBackend);
    };
    const handleSidebarCMSDashboardToggle = (openCMSDashboard) => {
        setIsopenCMSDashboard(openCMSDashboard);
        setIsopenCMSDashboard(openCMSDashboard);
    };

    const handleClick = (itemOptions) => {
        if (itemOptions.link) {
            let win = window.open(itemOptions.link, itemOptions.EventTarget);
            win.sessionStorage.clear();
        }
        else if (itemOptions.href) {
            navigate(itemOptions.href)
        }
    }

    const logoSidebarMenu = () => {
        return (
            <div className="logoDashboardSidebarWrapper">
                <Link to="/">
                    <img src={process.env.PUBLIC_URL + '/assets/images/logo/logo_trailboss.png'} className="logoDashboardSidebar" />
                </Link>
            </div>
        )
    }

    const initRender = (status) => {
        if (status == '200') {
            setMenuUpdate((prev) => {
                return prev;
            })
            if (sessionStorage.getItem('UserPermission')) {
                setMenuBind(true);
            }
        }
        else if (status == '401') {
            setMenuBind(false);
        }
    }

    //const MenuPermissioncheck = async () => {
    //    await initilizeUserInfo(initRender);
    //}
    useEffect(() => {
        // MenuPermissioncheck();
    }, [menuBind, menuUpdate, menuUpdateBackend])

    return (<>
        <div className="sidebarPanel">
            <div className="logoWrapper">
                <Link reloadDocument to='/' >
                    <img src={process.env.PUBLIC_URL + '/assets/images/logo/logo_trailboss.png'} className="logoDashboard" />
                </Link>
            </div>
            <div className="menuWrapper">
                <MultilevelSidebar
                    open={openCMS}
                    onToggle={() => handleSidebarCMSToggle()}
                    options={CMSOptionsWebsite}
                    header={logoSidebarMenu()}
                    onItemClick={handleClick}
                />
                <div onClick={() => handleSidebarCMSToggle(true)} className="MenuOpenIcon" title="Sidebar Menu">
                    <BsBrowserChrome size="20" color="#fff" />
                </div>
                <MultilevelSidebar
                    open={openCMSBackend}
                    onToggle={() => handleSidebarCMSBackendToggle()}
                    options={CMSOptions}
                    header={logoSidebarMenu()}
                    onItemClick={handleClick}
                />
                <div onClick={() => handleSidebarCMSBackendToggle(true)} className="MenuOpenIcon" title="Sidebar Menu">
                    <MdContactSupport size="20" color="#fff" />
                </div>
                <MultilevelSidebar
                    open={openCMSDashboard}
                    onToggle={() => handleSidebarCMSDashboardToggle()}
                    options={CMSOptionsDashboard}
                    header={logoSidebarMenu()}
                    onItemClick={handleClick}
                />
                <div onClick={() => handleSidebarCMSDashboardToggle(true)} className="MenuOpenIcon" title="Sidebar Menu">
                    <LuLayoutDashboard size="20" color="#fff" />
                </div>
            </div>
        </div>
    </>)
}

export default Sidebar;